var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"none","height":"28","viewBox":"0 0 40 28","width":"40","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M40 .666H0v26.667h40z","fill":"#ffda44"}}),_c('g',{attrs:{"fill":"#d80027"}},[_c('path',{attrs:{"d":"M40 .666H0v8.89h40zM40 18.444H0v8.889h40z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }